/* ============================================================
   Christmas World — Guides & Inspiration (blog repositioning)
   JS behaviours for the guides blog + article template.
   Separate file — does NOT modify cw-collection-content.js.
   The FAQ accordion reuses the same .cw-accordion* classes and
   markup pattern as cw-collection-content.js so the shared CSS
   styles it identically.
   ============================================================ */
(function () {
  'use strict';

  function init() {

  var bodyEl = document.querySelector('.cw-article-body');

  /* ---------- 1. CATEGORY CHIP SMOOTH SCROLL (blog landing) ---------- */
  var chips = document.querySelectorAll('.cw-guides-categories a[href^="#cw-cat-"]');
  chips.forEach(function (chip) {
    chip.addEventListener('click', function (e) {
      var target = document.querySelector(chip.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        chips.forEach(function (c) { c.classList.remove('is-active'); });
        chip.classList.add('is-active');
      }
    });
  });

  /* ---------- 2. ARTICLE: Quick Answer placement ---------- */
  /* The QA block is rendered in the template before the body.
     If the body starts with an intro paragraph, move the QA box
     to sit right after that intro paragraph. */
  var qaBlock = document.querySelector('.cw-qa-block');
  if (qaBlock && bodyEl) {
    var firstP = bodyEl.querySelector('p');
    if (firstP && firstP.nextElementSibling) {
      firstP.parentNode.insertBefore(qaBlock, firstP.nextSibling);
    }
  }

  /* ---------- 3. ARTICLE: CTA config ---------- */
  /* Data injected by the section template via a JSON script tag:
     cw-guides-data: { ctaUrl, ctaText, ctaMidText } */
  /* v1.1: no hard-coded fallback — CTA only renders when the template resolves one */
  var ctaConfig = { url: '', text: '', midText: '' };
  var cfgScript = document.getElementById('cw-guides-data');
  if (cfgScript) {
    try {
      var parsed = JSON.parse(cfgScript.textContent);
      if (parsed.ctaUrl) ctaConfig.url = parsed.ctaUrl;
      if (parsed.ctaText) ctaConfig.text = parsed.ctaText;
      if (parsed.ctaMidText) ctaConfig.midText = parsed.ctaMidText;
    } catch (e) { /* fall back to defaults */ }
  }

  /* ---------- 4. ARTICLE: heading IDs + TOC ---------- */
  if (bodyEl) {
    var h2s = bodyEl.querySelectorAll('h2');
    var tocList = document.querySelector('.cw-toc ol');
    var layout = document.querySelector('.cw-article-layout');

    h2s.forEach(function (h2, i) {
      if (!h2.id) {
        var base = (h2.textContent || '').toLowerCase()
          .replace(/[^a-z0-9\s-]/g, '').trim().replace(/\s+/g, '-')
          .slice(0, 60);
        h2.id = 'cw-sec-' + (base ? base : (i + 1));
      }
    });

    if (tocList && h2s.length >= 3) {
      h2s.forEach(function (h2) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + h2.id;
        a.textContent = h2.textContent;
        li.appendChild(a);
        tocList.appendChild(li);
      });
      if (layout) layout.classList.add('cw-toc-active');

      /* current-section highlighting */
      var tocLinks = tocList.querySelectorAll('a');
      if ('IntersectionObserver' in window && tocLinks.length) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              tocLinks.forEach(function (l) { l.classList.remove('is-current'); });
              tocLinks.forEach(function (l) {
                if (l.getAttribute('href') === '#' + entry.target.id) l.classList.add('is-current');
              });
            }
          });
        }, { rootMargin: '-90px 0px -65% 0px' });
        h2s.forEach(function (h2) { observer.observe(h2); });
      }

      /* mobile collapse */
      var tocTitle = document.querySelector('.cw-toc__title');
      var tocEl = document.querySelector('.cw-toc');
      if (tocTitle && tocEl && window.matchMedia('(max-width: 989px)').matches) {
        tocEl.classList.add('collapsed');
        tocTitle.addEventListener('click', function () {
          tocEl.classList.toggle('collapsed');
        });
      }
    }

    /* ---------- 5. ARTICLE: mid-article CTA ---------- */
    /* Inserted after the 2nd H2 (or after the QA block if only 1 H2). */
    if (h2s.length >= 2 && ctaConfig.url) {
      var ctaBox = document.createElement('div');
      ctaBox.className = 'cw-cta-inline';
      var ctaP = document.createElement('p');
      ctaP.className = 'cw-cta-inline__text';
      ctaP.textContent = ctaConfig.midText || 'Ready to shop? Explore the range.';
      var ctaA = document.createElement('a');
      ctaA.className = 'cw-cta-btn';
      ctaA.href = ctaConfig.url;
      ctaA.textContent = ctaConfig.text;
      ctaBox.appendChild(ctaP);
      ctaBox.appendChild(ctaA);
      h2s[1].parentNode.insertBefore(ctaBox, h2s[1]);
    }

      /* ---------- 6. ARTICLE: FAQ accordion support (v1.4, 29 Sep 2026) ---------- */
  /* The FAQ dropdowns themselves are built by cw-collection-content.js
     (Lyra's canonical builder — since its v1.4 it also targets
     .cw-article-body, so this file no longer builds a second accordion;
     the duplicate build broke the article FAQs). We only open the FIRST
     item by default on article pages. The builder may run before or after
     this script depending on script order, so poll briefly for the
     accordion (max 2s). */
  if (bodyEl) {
    var firstOpenTries = 0;
    var firstOpenTimer = setInterval(function () {
      firstOpenTries++;
      var acc = bodyEl.querySelector('.cw-accordion');
      if (acc) {
        if (!acc.querySelector('.cw-accordion-item.open')) {
          var firstItem = acc.querySelector('.cw-accordion-item');
          if (firstItem) {
            firstItem.classList.add('open');
            var fc = firstItem.querySelector('.cw-accordion-content');
            if (fc) fc.style.maxHeight = fc.scrollHeight + 'px';
          }
        }
        clearInterval(firstOpenTimer);
      } else if (firstOpenTries > 40) {
        clearInterval(firstOpenTimer);
      }
    }, 50);
  }
  }
  }
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* ── Topic grid: Load more guides (2026-10-07) ──
   Fetches the next ?page=N of the topic grid and appends the cards,
   replacing the broken native pagination (wrapp-hdt-facet-url links
   are collection-facet JS and do nothing on blog pages). */
(function () {
  "use strict";
  function initLoadMore() {
    var btn = document.querySelector("[data-cw-guides-loadmore]");
    if (!btn || btn.dataset.cwLmInit) return;
    btn.dataset.cwLmInit = "1";
    btn.addEventListener("click", function () {
      var url = btn.getAttribute("data-next-url");
      if (!url || btn.classList.contains("is-loading")) return;
      btn.classList.add("is-loading");
      var label = btn.querySelector(".cw-guides-loadmore__label");
      var oldText = label ? label.textContent : btn.textContent;
      if (label) label.textContent = "Loading\u2026";
      fetch(url, { headers: { "X-Requested-With": "cw-guides-loadmore" } })
        .then(function (r) { if (!r.ok) throw new Error("HTTP " + r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          var grid = document.querySelector(".cw-guides-grid");
          var cards = doc.querySelectorAll(".cw-guides-grid > .cw-guide-card__wrap");
          for (var i = 0; i < cards.length; i++) grid.appendChild(cards[i]);
          var nextBtn = doc.querySelector("[data-cw-guides-loadmore]");
          if (nextBtn && nextBtn.getAttribute("data-next-url")) {
            btn.setAttribute("data-next-url", nextBtn.getAttribute("data-next-url"));
            btn.classList.remove("is-loading");
            if (label) label.textContent = oldText;
          } else {
            var wrap = btn.closest(".cw-guides-loadmore");
            if (wrap) wrap.style.display = "none";
          }
        })
        .catch(function () {
          btn.classList.remove("is-loading");
          if (label) label.textContent = oldText;
          window.location.href = url; /* graceful fallback: plain navigation */
        });
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initLoadMore);
  else initLoadMore();
})();
